import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import './SearchVehicles.css';
import { useNavigate } from 'react-router-dom';

const SearchVehicles = () => {
    const [makers, setMakers] = useState([]);
    const [selectedMaker, setSelectedMaker] = useState('');
    const [models, setModels] = useState([]);
    const [selectedModel, setSelectedModel] = useState('');
    const [years, setYears] = useState([]);
    const [selectedYearFrom, setSelectedYearFrom] = useState('');
    const [selectedYearTo, setSelectedYearTo] = useState('');
    const [prices, setPrices] = useState([]);
    const [selectedPriceFrom, setSelectedPriceFrom] = useState('');
    const [selectedPriceTo, setSelectedPriceTo] = useState('');
    const [vins, setVins] = useState([]);
    const [selectedVin, setSelectedVin] = useState('');
    const [mileages, setMileages] = useState([]);
    const [selectedMileage, setSelectedMileage] = useState('');
    const [fuels, setFuels] = useState([]);
    const [selectedFuel, setSelectedFuel] = useState('');
    const [transmissions, setTransmissions] = useState([]);
    const [selectedTransmission, setSelectedTransmission] = useState('');
    const [bodyTypes, setBodyTypes] = useState([]);
    const [selectedBodyType, setSelectedBodyType] = useState('');
    const [colors, setColors] = useState([]);
    const [selectedColor, setSelectedColor] = useState('');
    const [isFormVisible, setIsFormVisible] = useState(false); // State for toggling form visibility
    const navigate = useNavigate();

    useEffect(() => {
        fetch('https://skcapi.btcjapan.co/getDropdownOptions.php')
            .then(response => response.json())
            .then(data => setMakers(data))
            .catch(error => console.error('Error fetching makers:', error));

        fetch('https://skcapi.btcjapan.co/getYears.php')
            .then(response => response.json())
            .then(data => setYears(data))
            .catch(error => console.error('Error fetching years:', error));

        fetch('https://skcapi.btcjapan.co/getPrices.php')
            .then(response => response.json())
            .then(data => setPrices(data))
            .catch(error => console.error('Error fetching prices:', error));

        fetch('https://skcapi.btcjapan.co/getVins.php')
            .then(response => response.json())
            .then(data => setVins(data))
            .catch(error => console.error('Error fetching VINs:', error));

        fetch('https://skcapi.btcjapan.co/getMileages.php')
            .then(response => response.json())
            .then(data => setMileages(data))
            .catch(error => console.error('Error fetching mileages:', error));

        fetch('https://skcapi.btcjapan.co/getFuels.php')
            .then(response => response.json())
            .then(data => setFuels(data))
            .catch(error => console.error('Error fetching fuels:', error));

        fetch('https://skcapi.btcjapan.co/getTransmissions.php')
            .then(response => response.json())
            .then(data => setTransmissions(data))
            .catch(error => console.error('Error fetching transmissions:', error));

        fetch('https://skcapi.btcjapan.co/getBodyTypes.php')
            .then(response => response.json())
            .then(data => setBodyTypes(data))
            .catch(error => console.error('Error fetching body types:', error));

        fetch('https://skcapi.btcjapan.co/getColors.php')
            .then(response => response.json())
            .then(data => setColors(data))
            .catch(error => console.error('Error fetching colors:', error));
    }, []);

    const handleMakerChange = (event) => {
        const maker = event.target.value;
        setSelectedMaker(maker);
        setSelectedModel('');
        fetch(`https://skcapi.btcjapan.co/getModels.php?maker=${maker}`)
            .then(response => response.json())
            .then(data => setModels(data))
            .catch(error => console.error('Error fetching models:', error));
    };

    const handleModelChange = (event) => {
        setSelectedModel(event.target.value);
    };

    const handleYearFromChange = (event) => {
        setSelectedYearFrom(event.target.value);
    };

    const handleYearToChange = (event) => {
        setSelectedYearTo(event.target.value);
    };

    const handlePriceFromChange = (event) => {
        setSelectedPriceFrom(event.target.value);
    };

    const handlePriceToChange = (event) => {
        setSelectedPriceTo(event.target.value);
    };

    const handleVinChange = (event) => {
        setSelectedVin(event.target.value);
    };

    const handleMileageChange = (event) => {
        setSelectedMileage(event.target.value);
    };

    const handleFuelChange = (event) => {
        setSelectedFuel(event.target.value);
    };

    const handleTransmissionChange = (event) => {
        setSelectedTransmission(event.target.value);
    };

    const handleBodyTypeChange = (event) => {
        setSelectedBodyType(event.target.value);
    };

    const handleColorChange = (event) => {
        setSelectedColor(event.target.value);
    };

    const handleSearch = (event) => {
        event.preventDefault();
        navigate('/search-result', {
            state: {
                maker: selectedMaker,
                model: selectedModel,
                yearFrom: selectedYearFrom,
                yearTo: selectedYearTo,
                priceFrom: selectedPriceFrom,
                priceTo: selectedPriceTo,
                vin: selectedVin,
                mileage: selectedMileage,
                fuel: selectedFuel,
                transmission: selectedTransmission,
                bodyType: selectedBodyType,
                color: selectedColor,
            },
        });
    };

    const toggleFormVisibility = () => {
        setIsFormVisible(!isFormVisible);
    };

    return (
        <section className="container">
            <div className="serchmainbox">
                <div className="header-container" onClick={toggleFormVisibility}>
                    <h5>
                        Click to view search details &nbsp;&nbsp;&nbsp;
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-journal-arrow-down" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M8 5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5A.5.5 0 0 1 8 5" />
                            <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
                            <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
                        </svg>
                    </h5>
                    <svg
                        className={`arrow-icon ${isFormVisible ? 'open' : ''}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                    >
                        <path
                            fillRule="evenodd"
                            d="M8 12a.5.5 0 0 0 .5-.5V4.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 .5.5z"
                        />
                        <path
                            fillRule="evenodd"
                            d="M4.646 8.354a.5.5 0 0 0 .708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L3.707 10H12.5a.5.5 0 0 0 0-1H3.707l2.647-2.646a.5.5 0 0 0-.708-.708l-3 3z"
                        />
                    </svg>
                </div>
                {isFormVisible && (
                    <form onSubmit={handleSearch}>
                        <div className="row">
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="make" className="form-label text-black">Maker</label>
                                <select id="make" className="form-select" onChange={handleMakerChange}>
                                    <option value="">Select</option>
                                    {makers.map((maker, index) => (
                                        <option key={index} value={maker}>{maker}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="model" className="form-label text-black">Model</label>
                                <select id="model" className="form-select" onChange={handleModelChange}>
                                    <option value="">Select</option>
                                    {models.map((model, index) => (
                                        <option key={index} value={model}>{model}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="yearFrom" className="form-label text-black">Year From</label>
                                <select id="yearFrom" className="form-select" onChange={handleYearFromChange}>
                                    <option value="">Select</option>
                                    {years.map((year, index) => (
                                        <option key={index} value={year}>{year}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="yearTo" className="form-label text-black">Year To</label>
                                <select id="yearTo" className="form-select" onChange={handleYearToChange}>
                                    <option value="">Select</option>
                                    {years.map((year, index) => (
                                        <option key={index} value={year}>{year}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="priceFrom" className="form-label text-black">Price From</label>
                                <select id="priceFrom" className="form-select" onChange={handlePriceFromChange}>
                                    <option value="">Select</option>
                                    {prices.map((price, index) => (
                                        <option key={index} value={price}>{price}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="priceTo" className="form-label text-black">Price To</label>
                                <select id="priceTo" className="form-select" onChange={handlePriceToChange}>
                                    <option value="">Select</option>
                                    {prices.map((price, index) => (
                                        <option key={index} value={price}>{price}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="vin" className="form-label text-black">VIN</label>
                                <select id="vin" className="form-select" onChange={handleVinChange}>
                                    <option value="">Select</option>
                                    {vins.map((vin, index) => (
                                        <option key={index} value={vin}>{vin}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="mileage" className="form-label text-black">Mileage</label>
                                <select id="mileage" className="form-select" onChange={handleMileageChange}>
                                    <option value="">Select</option>
                                    {mileages.map((mileage, index) => (
                                        <option key={index} value={mileage}>{mileage}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="fuel" className="form-label text-black">Fuel</label>
                                <select id="fuel" className="form-select" onChange={handleFuelChange}>
                                    <option value="">Select</option>
                                    {fuels.map((fuel, index) => (
                                        <option key={index} value={fuel}>{fuel}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="transmission" className="form-label text-black">Transmission</label>
                                <select id="transmission" className="form-select" onChange={handleTransmissionChange}>
                                    <option value="">Select</option>
                                    {transmissions.map((transmission, index) => (
                                        <option key={index} value={transmission}>{transmission}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="bodyType" className="form-label text-black">Body Type</label>
                                <select id="bodyType" className="form-select" onChange={handleBodyTypeChange}>
                                    <option value="">Select</option>
                                    {bodyTypes.map((bodyType, index) => (
                                        <option key={index} value={bodyType}>{bodyType}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                                <label htmlFor="color" className="form-label text-black">Color</label>
                                <select id="color" className="form-select" onChange={handleColorChange}>
                                    <option value="">Select</option>
                                    {colors.map((color, index) => (
                                        <option key={index} value={color}>{color}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="container mt-2">
                            <div className="row">
                                <div className="col text-end">
                                    <button type="submit" className="btn btn-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" className="searchicon" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                        </svg>
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </section>
    );
};

export default SearchVehicles;